import React from "react";
import BigCalendar, { Views } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import moment from "moment";
import CalendarEvent from "../../CalendarEvent/CalendarEvent.js";
import { CalendarWrapper } from "../../CalendarWrapper";
import { EventWrapper } from "../../EventWrapper/EventWrapper";
import { prepareEvents } from "../../utilities";
import { CALENDAR_VIEWS } from "../../calendarShared";

const localizer = BigCalendar.momentLocalizer(moment);
const DragAndDropCalendar = withDragAndDrop(BigCalendar);
const noop = () => {};

export function CalendarDragAndDrop({
  events,
  min,
  max,
  resources,
  onEventDrop,
  view,
  onSelectSlot,
  onSelectEvent,
  step,
  timeslots,
  date,
  getNow,
  timeFormat,
  timeRangeFormat,
}) {
  const calendarView = view === CALENDAR_VIEWS.verticals ? Views.DAY : view;

  return (
    <CalendarWrapper>
      <DragAndDropCalendar
        selectable
        formats={{
          timeGutterFormat: timeFormat,
          eventTimeRangeFormat: timeRangeFormat,
          selectRangeFormat: timeRangeFormat,
        }}
        localizer={localizer}
        views={[Views.WEEK, Views.DAY]}
        events={prepareEvents(events)}
        min={min}
        max={max}
        resources={resources}
        resourceIdAccessor="resourceId"
        resourceTitleAccessor="resourceTitle"
        onEventDrop={onEventDrop}
        view={calendarView}
        onView={noop}
        defaultDate={new Date(2019, 0, 29)}
        onSelectSlot={onSelectSlot}
        onSelectEvent={onSelectEvent}
        step={step}
        timeslots={timeslots}
        showMultiDayTimes
        toolbar={false}
        date={date}
        onNavigate={noop}
        getNow={getNow}
        components={{
          event: CalendarEvent,
          eventWrapper: EventWrapper,
        }}
      />
    </CalendarWrapper>
  );
}
